import { apiGet, apiSend } from './client';

export interface AdminUserPublic {
  username: string;
  createdAt: string;
}

export function listUsers(): Promise<AdminUserPublic[]> {
  return apiGet<AdminUserPublic[]>('/users');
}

export function createUser(username: string, password: string): Promise<AdminUserPublic> {
  return apiSend<AdminUserPublic>('/users', 'POST', { username, password }) as Promise<AdminUserPublic>;
}

export function deleteUser(username: string): Promise<null> {
  return apiSend<null>(`/users/${encodeURIComponent(username)}`, 'DELETE');
}

export function changePassword(
  username: string,
  newPassword: string,
  currentPassword?: string,
): Promise<null> {
  return apiSend<null>(
    `/users/${encodeURIComponent(username)}/password`,
    'PUT',
    { newPassword, currentPassword },
  );
}
